import React from "react";
import flechaAvanzar from "../assets/right-arrow.svg";
import silentAvatar from "../assets/avatares/sin-sonido.mp4";
import "../pages/StartGame.css";

/**
 * Layout común para start-game 2–5: fondo, avatar silencioso en bucle, panel y CTA.
 * `brandTheme`: pasos 2–4 comparten estética con /start-game (burdeos + CTA claro). El paso 5 aplica el mismo tema en `StartGame5.js`.
 */
export default function StartGameFlowLayout({
	stepKicker,
	sidebarTitle,
	footerHint,
	loading,
	onContinue,
	children,
	video,
	/** Misma estética burdeos que /start-game (pasos 2–4 reglas). */
	brandTheme = false,
}) {
	return (
		<div
			className={`start-game-page${brandTheme ? " start-game-page--welcome" : ""}`}
		>
			<div className="start-game-inner">
				<div className="start-game-grid">
					<div className="start-game-visual start-game-visual--flow">
						<span className="start-game-badge">
							<span className="start-game-badge-dot" aria-hidden />
							Fepol
						</span>
						<div className="start-game-avatar-wrap start-game-avatar-wrap--silent">
							<div className="start-game-avatar-inner start-game-avatar-inner--silent">
								<video
									autoPlay
									playsInline
									preload="auto"
									aria-label="Animación del asistente"
								>
									<source src={video? video : silentAvatar} type="video/mp4" />
								</video>
							</div>
						</div>
						{sidebarTitle ? (
							<h2 className="start-game-sidebar-title">{sidebarTitle}</h2>
						) : null}
					</div>

					<div className="start-game-panel start-game-panel--rules">
						{stepKicker ? (
							<p className="start-game-kicker">{stepKicker}</p>
						) : null}
						{children}
						<div
							className={`start-game-footer start-game-footer--flow${footerHint ? "" : " start-game-footer--no-hint"}`}
						>
							{footerHint ? (
								<span className="start-game-hint">{footerHint}</span>
							) : null}
							<button
								type="button"
								className="start-game-cta mb-3"
								onClick={(e) => {
									e.preventDefault();
									if (!loading) onContinue(e);
								}}
								disabled={loading}
								aria-busy={loading}
							>
								{loading ? (
									<span className="start-game-cta-spinner" aria-hidden />
								) : (
									<img
										className="start-game-cta-icon"
										src={flechaAvanzar}
										alt=""
									/>
								)}
								{loading ? "Cargando…" : "Continuar"}
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
